<template>
  <div id="app">
    <SkipNav />
    <OfficialSite />
    <AppHeader />

    <transition mode="out-in"
                enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut">
      <main id="mainContent">
        <router-view v-slot="{ Component }">
            <component :is="Component" />
        </router-view>
      </main>
    </transition>
    <AppFooter />

    <!-- full screen spinner -->
    <ModalSpinner />
  </div>
</template>

<script setup>
import SkipNav from '@/components/SkipNav'
import OfficialSite from '@/components/OfficialSite'
import ModalSpinner from '@/components/appModal/ModalSpinner'
import AppFooter from './components/AppFooter.vue'
import AppHeader from './components/AppHeader.vue'
</script>

<style lang="scss">
@import "~@ridmv/web-themes";
@import "~animate.css";
.animate__animated.animate__fadeOut {
  --animate-duration: .35s;
}
</style>

